export const formatAmount = (value: number) =>
    value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }
);

export const formatAmountAttachableRider = (value: number | string) => {
    if (value === "" || value === null || value === undefined) return "";
    const num = typeof value === "number" ? value : Number(value);
    return num.toLocaleString("en-US");
};

// number to string 1000 => 1,000
export const formatAmountType = (value: number) => {
    return value.toLocaleString('en-US');
}

export const formatNumberWithComma = (value: number | string) => {
    if (!value) return '';
    return Number(value).toLocaleString('en-US');
};